export default function getStaticFile(fileName) {
    return `${window.env.STATIC_ROOT}${fileName}`;
}
